import { Component, Input, OnInit } from '@angular/core';
import { Shape, Sizes, SkeletonSizeBase } from '../../../common';
import { getAvatarSizes, getSizes } from '../../../common/utils/utils';

@Component({
  selector: 'skc-facebook-list',
  templateUrl: './facebook-list.component.html',
  styleUrls: ['./facebook-list.component.less']
})
export class FacebookListComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-shape') shape = Shape.CIRCLE;
  @Input('skc-border-radius') borderRadius;
  @Input('skc-avatar-size') avatarSize: Sizes;
  @Input('skc-line-height') lineHeight;
  size;
  lHeight;
  constructor() {
    super();
  }
  ngOnInit() {
    this.size = getAvatarSizes(this.avatarSize);
    this.lHeight = getSizes(this.lineHeight);
  }
}
